/**
 * The one place OMASE colours are defined.
 *
 * `tailwind.config.js` builds both the utility palette and the DaisyUI theme
 * from this object, and the canvas renderer (which cannot use CSS classes)
 * imports the few values it needs. Nothing else should contain a hex literal.
 */
export const palette = {
  // `brand` is the identity green: safe for fills, borders, dots, and large
  // text (4.34:1 on white — above the 3:1 non-text/large-text bar, below the
  // 4.5:1 small-text bar). Small text and button fills use `brandDeep`, which
  // clears 6:1. Verified with the ratios in README › Colour contrast.
  brand: '#0f8a63',
  brandDeep: '#0b6b4d',
  brandDeeper: '#0a6247',
  brandSoft: '#37b98a',
  brandTint: '#cdeee0',
  ink: '#10161c',
  muted: '#4a5760',
  faint: '#5b666e',
  dim: '#66727a',
  hairline: '#e3e8e5',
  hairlineSoft: '#eceeec',
  canvas: '#fbfcfb',
  canvasAlt: '#f6f8f7',
  night: '#0d1418',
  nightCard: '#0f171b',
  nightLine: '#1d2a2f',
  nightLineSoft: '#1b262b',
  nightText: '#eef2f0',
  nightMuted: '#9fb0ac',
  warn: '#9a6c12',
  info: '#1d5f6e',
  error: '#b3261e',
  // WhatsApp brand greens, kept verbatim because brand recognition is the point.
  // `whatsapp` (#25d366) is a FILL only — as a glyph colour it is 1.98:1 on
  // white, far under the 3:1 floor for meaningful icons.
  // `whatsappInk` (#128c7e, WhatsApp's own teal) is the glyph colour: 4.14:1 on
  // white, 3.88:1 on canvas-alt, 4.49:1 on night — the one green that clears
  // the bar on every surface this page uses, light or dark.
  whatsapp: '#25d366',
  whatsappDeep: '#1ebe5a',
  whatsappInk: '#128c7e'
}

export default palette
